<template>
    <div class="indexPage" style="height: 100%;">

        <headfix></headfix>
        <div class="common-banner">
            <div class="bg-img" v-for="(item,index) in advList"><img :src="item.advImages"/></div>
        </div>


        <div class="cate-pic">
            <div class="cate-pic-item" :class="cateClass1 ? 'on' : ''" @click="goCate_(cateInfo1)" @mouseover="mouseOver" @mouseleave="mouseLeave">
                <div class="thumb"><img :src="cateClass1 ? cateInfo1.categoryThumb : cateInfo1.categoryJson"/></div>
                <div class="txt">
                    <div class="t1">{{cateInfo1.categoryName}}</div>
                    <div class="t2">{{cateInfo1.code}}{{cateInfo1.categoryTitle}}</div>
                </div>
            </div>
            <div class="cate-pic-item c1" :class="!cateClass1 ? 'on' : ''" @click="goCate_(cateInfo2)">
                <div class="thumb"><img :src="!cateClass1 ? cateInfo2.categoryThumb : cateInfo2.categoryJson"/></div>
                <div class="txt">
                    <div class="t1">{{cateInfo2.categoryName}}</div>
                    <div class="t2">{{cateInfo2.code}}{{cateInfo2.categoryTitle}}</div>
                </div>
            </div>
        </div>


        <div class="wraper-box" style="position: relative;">
            <div class="cate-title">
                <div class="cate-title-top">{{categoryInfo.categoryName}}</div>
                <div class="cate-title-bottom"><span class="t1">{{categoryInfo.code}}</span><span class="t2">{{categoryInfo.categoryTitle}}</span>
                </div>
            </div>

            <div class="product2-list">
                <ul>
                    <li v-for="(item,index) in productList" @click="goProductDetail(item)">
                        <a href="javascript:;" v-if="index%2==0">
                            <div class="product2-pic"><img :src="item.thumb"/></div>
                            <div class="product2-into">
                                <div class="product2-head">
                                    <div class="title">{{item.title}}</div>
                                    <div class="en-title">{{item.keywords}}</div>
                                    <div class="icon"></div>
                                </div>
                                <div class="product2-desc">{{item.description}}</div>

                                <div class="bt">
                                    <div class="b1">
                                        <div class="text1">{{item.buyUrl}}</div>
                                        <div class="text2">用户选择率</div>
                                    </div>
                                    <div class="b2">
                                        <div class="text3">产品优势</div>
                                        <div class="tlist" v-if="item.attrValueList">
                                            <div class="label" v-for="(val, idx) in item.attrValueList">
                                                {{val.attrValueName}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </a>
                        <a href="javascript:;" v-else>
                            <div class="product2-into">
                                <div class="product2-head">
                                    <div class="title">{{item.title}}</div>
                                    <div class="en-title">{{item.keywords}}</div>
                                    <div class="icon"></div>
                                </div>
                                <div class="product2-desc">{{item.description}}</div>

                                <div class="bt">
                                    <div class="b1">
                                        <div class="text1">{{item.buyUrl}}</div>
                                        <div class="text2">用户选择率</div>
                                    </div>
                                    <div class="b2">
                                        <div class="text3">产品优势</div>
                                        <div class="tlist" v-if="item.attrValueList">
                                            <div class="label" v-for="(val, idx) in item.attrValueList">
                                                {{val.attrValueName}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="product2-pic"><img :src="item.thumb"/></div>
                        </a>
                    </li>

                </ul>
                <div class="clearfix"></div>
            </div>

        </div>

        <footerfix></footerfix>


    </div>
</template>
<script>
    import headfix from '@/components/utils/headfix';
    import footerfix from '@/components/utils/footerfix';
    import {settingInfo_, goCate_, categoryTree_} from '@/components/js/app'

    export default {
        components: {headfix, footerfix},
        data() {
            return {
                cateClass1: false,
                categoryInfo: {},
                productList: [],
                advList: [],
                cateInfo1: {},
                cateInfo2: {},
                tabIndex: -1,
                currentId: 0,
            }
        },
        created() {
            this.currentId = this.$route.query.cateId;
            this.$nextTick(() => {
                this.getCategoryData(this.currentId);
                this.getProductListData(this.currentId);
                this.categoryTree();

                if (this.currentId == 42) {
                    this.getAdvData(58);
                }
                if (this.currentId == 43) {
                    this.getAdvData(59);
                }
                if (this.currentId == 44) {
                    this.getAdvData(60);
                }
            })
        },
        mounted() {
            document.querySelector('body').setAttribute('style', 'background-color:#faf9f5')
        },
        beforeDestroy() {
            document.querySelector('body').removeAttribute('style')
        },
        methods: {
            goCate_,
            // 分类详情
            getCategoryData(categoryId) {
                this.$post_('api/cms-category/info', {id: categoryId}, (res) => {
                    if (res.code == 1) {
                        this.categoryInfo = res.data;
                    } else {
                        this.$message.error(res.message);
                    }
                })
            },
            // 产品列表
            getProductListData(categoryId) {
                let data = {
                    model_id: 4,
                    categoryId: categoryId
                }
                this.$post_('api/cms-product/product-page', {page: 1, size: 40, data: data}, (res) => {
                    if (res.code == 1) {
                        this.productList = res.data.records;
                    } else {
                        this.$message.error(res.message);
                    }
                })
            },
            // 分类广告
            getAdvData(positionId) {
                this.$post_('api/adv/adv-list', {catId: positionId}, (res) => {
                    if (res.code == 1) {
                        this.advList = res.data;
                    } else {
                        this.$message.error(res.message);
                    }
                })
            },
            goProductDetail(item) {
                this.$router.push({path: '/productDetail', query: {cateId: item.categoryId, id: item.id}});
            },
            categoryTree() {
                categoryTree_((res) => {
                    if (res.code == 1) {
                        for (let i = 0; i < res.data.length; i++) {
                            if (res.data[i].id == 36) {

                                for (let j = 0; j < res.data[i].children.length; j++) {
                                    if (res.data[i].children[j].id == 37) {
                                        this.cateInfo1 = res.data[i].children[j];
                                    }
                                    if (res.data[i].children[j].id == 38) {
                                        this.cateInfo2 = res.data[i].children[j];
                                    }
                                }
                            }
                        }
                    } else {
                        this.$message.error(res.message);
                    }
                }, false);
            },
            mouseOver() {
                this.cateClass1 = true;
            },
            mouseLeave() {
                this.cateClass1 = false;
            },
            goCate(id) {
                if (id == 36 || id == 37) {
                    id = 39;
                }
                if (id == 38) {
                    id = 42;
                }
                if (id == 39 || id == 40 || id == 41) {
                    this.$router.push({path: '/product', query: {cateId: id}});
                }
                if (id == 42 || id == 43 || id == 44) {
                    this.$router.push({path: '/product2', query: {cateId: id}});
                }
            }
        }
    }
</script>

<style scoped>

    .product2-list {
        padding-bottom: 80px;
    }

    .product2-list li {
    }

    .product2-list li a {
        display: flex;
        height: 600px;
        margin-bottom: 50px;
        overflow: hidden;
        box-sizing: border-box;
        padding-bottom: 40px;
    }

    .product2-pic {
        padding: 60px 0px;
        height: 100%;
        flex: 1;
    }

    .product2-pic img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .product2-into {
        width: 400px;
        box-shadow: -2px 2px 13px 5px #CCCCCC;
        border-top: #ec9666 8px solid;
        padding: 20px;
        box-sizing: border-box;
        position: relative;
        background: #FFFFFF;
    }

    .product2-head {
        border-bottom: #CCCCCC 1px solid;
        position: relative;
    }

    .product2-head .icon {
        width: 28px;
        height: 28px;
        background: url("../../assets/img/product_detail_icon.png") no-repeat;
        position: absolute;
        bottom: 20px;
        right: 0px;
        background-size: 80% 80%;
    }

    .product2-head .title {
        font-size: 38px;
        font-weight: bold;
        margin-top: 30px;
    }

    .product2-head .en-title {
        font-size: 14px;
        color: #b7b7b7;
        margin-bottom: 25px;
        margin-top: 10px;
    }

    .product2-desc {
        font-size: 14px;
        margin-top: 30px;
        color: #969696;
        line-height: 22px;
        height: 180px;
        overflow: hidden;
    }

    .bt {
        position: absolute;
        bottom: 40px;
        width: calc(100% - 20px);
    }

    .bt .b1 {
        float: left;
        margin-right: 20px;
    }

    .text1 {
        font-size: 80px;
        color: #e56b28;
        font-weight: 500;
    }

    .text2 {
        text-align: center;
        color: #CCCCCC;
        font-size: 14px;
    }

    .bt .b2 {
        float: left;
        margin-top: 30px;
    }

    .text3 {
        color: #000000;
        margin-bottom: 8px;
        font-weight: 600;
        font-size: 16px;
    }

    .tlist {
        display: flex;
    }

    .tlist .label {
        background: #f3ba9c;
        color: #FFFFFF;
        font-size: 12px;
        border-radius: 10px;
        margin-right: 10px;
        padding: 2px 8px;
    }


    /*产品中心-筛选*/

    @media (max-width: 1799px) {

    }

    @media (max-width: 1199px) {
        .product2-list li a {
            height: 500px;
        }

        .product2-into {
            width: 300px;
        }

        .product2-head .title {
            font-size: 28px;
            margin-top: 15px;
        }

        .product2-head .icon {
            background-size: 60% 60%;
            bottom: 15px;
        }

        .product2-desc {
            height: 130px;
            overflow: hidden;
            margin-top: 15px;
        }

        .text1 {
            font-size: 60px;
            color: #e56b28;
            font-weight: 500;
        }

        .bt .b2 {
            float: left;
            margin-top: 15px;
        }
    }

    @media (max-width: 993px) {
        .product2-list li a {
            height: auto;
            display: block;
            margin: 15px;
            margin-bottom: 50px;
            box-shadow: -2px 2px 13px 5px #CCCCCC;
            padding-bottom: 0px;
        }

        .product2-pic {
            padding: 0px;
            width: 100%;
            height: 220px;
        }

        .product2-into {
            height: 500px;
            width: 100%;
            border-top: none;
            box-shadow: none;
        }


    }

    @media (max-width: 767px) {


    }


</style>
